import Pagination from "../../../components/pagination/Pagination";
import connect from "react-redux/es/connect/connect";

const mapStateToProps = state => {
  return {
    page: state.phototheque.page,
    pages: state.phototheque.pages,
    pageSize: state.phototheque.pageSize,
    nbItems: state.phototheque.medias.length
  };
};

export default connect(mapStateToProps)(Pagination);



// WEBPACK FOOTER //
// src/containers/activite/phototeque/PaginationContainer.js